import { useConversations } from '../api/getConversations';

import { Spinner } from 'components/Elements';
import clsx from 'clsx';
import { useState } from 'react';
import { useMessagingSocket } from 'providers/messaging';
import { Logo } from 'components/Layout';

export const Sidebar = ({ selectedConversation, onSelectConversation }) => {
  const { data, isLoading } = useConversations();
  const { connected, unreadCounts, presence } = useMessagingSocket();
  const conversations = data?.conversations || [];
  const [query, setQuery] = useState('');

  const filtered = conversations.filter((c) =>
    (c.groupName || c.otherUser?.name || '').toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className=" h-full shadow flex flex-col overflow-hidden">
      {/* Header */}
      <div className="bg-gray-800 border-b border-gray-700 p-4 h-20 flex items-center justify-between">
        <Logo />
        <span
          className={clsx(
            'text-xs font-semibold px-2 py-1 rounded',
            connected ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'
          )}
        >
          {connected ? 'Online' : 'Offline'}
        </span>
      </div>

      {/* Search */}
      <div className="p-3 border-b border-gray-700 flex gap-2 items-center">
        <input
          className="bg-transparent border border-gray-700 outline-none rounded-md p-2 text-sm flex-1"
          placeholder="Search conversations"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {/* List */}
      <div className="overflow-y-auto flex-1 p-2">
        {isLoading ? (
          <Spinner />
        ) : filtered.length === 0 ? (
          <div className="text-gray-400 text-center mt-10">No conversations</div>
        ) : (
          <div className="flex flex-col gap-2">
            {filtered.map((c) => {
              const convoId = c._id;
              const unread = unreadCounts[convoId] || 0;
              const isActive = selectedConversation?._id === convoId;

              return (
                <div
                  key={convoId}
                  onClick={() => onSelectConversation(c)}
                  className={clsx(
                    'flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-all',
                    isActive ? 'bg-gray-700 border-l-4 border-[#FC4C12]' : 'hover:bg-gray-800'
                  )}
                >
                  <div className="relative">
                    <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center font-semibold text-gray-600">
                      {(c.groupName?.[0] || c.otherUser?.name?.[0] || 'J').toUpperCase()}
                    </div>
                    {presence[c.otherUser?._id] && (
                      <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border border-white rounded-full"></span>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-medium text-white text-sm truncate">
                      {c.groupName || c.otherUser?.name || 'Conversation'}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {c.lastMessage?.content || 'No messages yet'}
                    </div>
                  </div>
                  {unread > 0 && (
                    <span className="bg-blue-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                      {unread}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
